export default "__VITE_ASSET__BQf5CmcI__"